var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"article-listing scroll-performance"},_vm._l((_vm.articles),function(article,index){return _c('card',{key:article.id,attrs:{"article":article,"index":index}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }